import img from "assets/images/illustrations/image7.webp";
import ContactNumberContent from "components/sections/home/components/ContactNumberContent";

function ContactNumber() {
  return (
    <>
      <div className="home__contact-container container">
        <div className="home__contact-wrapper">
          <div className="home__contact-content">
            <h1>
              Keni nevojë për <span>informata shtesë?</span>{" "}
            </h1>
            <h2>Lejeni numrin tuaj të telefonit.</h2>
            <ContactNumberContent />
          </div>
          <div className="home__contact-img">
            <img loading="lazy" src={img} alt="Contact" />
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactNumber;
